import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PackageContentDayService', PackageContentDayService);

  PackageContentDayService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'TranslationModalService',
    'WindowModalService',
    'UploadService',
  ];

  function PackageContentDayService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    TranslationModalService,
    WindowModalService,
    UploadService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'package_contents';

    var service = {
      getPackageContentDay: getPackageContentDay,
      savePackageContentDay: savePackageContentDay,
      openLogo: openLogo,
      updateLogo: updateLogo,
      openPackageContentDayTranslations: openPackageContentDayTranslations,
      openPackageContentDayDetailModal: openPackageContentDayDetailModal,
    };

    return service;

    ////////////////

    function getPackageContentDay(dayId, packageContentId, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      var url = apiUrl + '/' + packageContentId + '/package_content_days/' + dayId;

      return RestResource.request(
        'get',
        url,
        params,
        function (response) {
          response.data.logoUrl = utils.cleanItemCache(response.data, 'logo');
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function savePackageContentDay(item, packageContentId, language, cropedImage) {
      var url = apiUrl + '/' + packageContentId + '/package_content_days/' + item.id;

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;
      url = url + '?lang=' + lang;

      return UploadService.uploadFile(
        'put',
        url,
        'package_content_day',
        item,
        cropedImage,
        function () {},
        function (response) {
          var msg = item.id ? 'DAY_MODIFIED' : 'DAY_ADDED';
          utils._successMsg($translate(msg));

          return response;
        },
        function () {}
      );
    }

    function openPackageContentDayTranslations(item, packageContentId, additionalLanguages) {
      var template =
        './app/ajs/package-contents/package-content-days/modals/package-content-day-detail-translation.html';

      var modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return service
          .getPackageContentDay(itemId, packageContentId, language, 'translate')
          .then(function (data) {
            return data;
          });
      };

      var confirmCallback = function (item, language) {
        return service
          .savePackageContentDay(item, packageContentId, language, '')
          .then(function (data) {
            if (!data.status) {
              return data.response;
            }

            return false;
          });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function openLogo(item, saveLogoCallBack) {
      utils.openLogo(item, saveLogoCallBack);
    }

    // Update logo after crop
    function updateLogo(item, packageContentId, cropedImage, successCallback) {
      var url =
        apiUrl +
        '/' +
        packageContentId +
        '/package_content_days/' +
        item.id +
        '?lang=' +
        config.DEFAULT_CONTENT_LANGUAGE;

      utils.updateLogo(url, 'package_content_day', item, cropedImage, successCallback);
    }

    function openPackageContentDayDetailModal(
      item,
      mode,
      packageContent,
      defaultLanguage,
      additionalLanguages,
      successCallback
    ) {
      var templateUrl =
        './app/ajs/package-contents/package-content-days/modals/package-content-day-detail-modal.html';

      var originalItem = angular.copy(item);

      var modalParams = {
        title: 'DAY_DETAILS',
        item: originalItem,
        mode: mode,
        parentOptions: packageContent,
        defaultLanguage: defaultLanguage,
        additionalLanguages: additionalLanguages,
        preventModalClose: true,
        closeOnSave: null,
      };

      // if (!item.id){
      modalParams.closeOnSave = false; // Do not close modal after create
      // }

      // onSavedItem in modal service
      var confirmCallback = function (day) {
        if (item.id) {
          // Edit
          if (!day.logoUpdated) {
            item.name = day.name;
            item.description = day.description;
            item.url_video = day.url_video;
            item.included = day.included;
            item.excluded = day.excluded;
            item.notes = day.notes;
            item.package_day_id = day.package_day_id;
            item.photos = day.photos;

            item.package_day = day.package_day;
          }

          item.logo = day.logo;
          item.logoUrl = utils.cleanItemCache(day, 'logo');

          return utils.itemListChanged(day.id);
        }

        return successCallback(day);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }
  }
})();
